import * as types from '../actions/notifications';

export default function clearNotificationAction(closeImmediately = false) {
  return {
    type: types.CLEAR_NOTIFICATION,
    closeImmediately,
  };
}
